import React from "react";
import { Route, Routes } from "react-router-dom";
import PriceRequestList from "../layout/priceRequest/PriceRequestList";

function PriceRequestPage() {
    return (
        <Routes>
            <Route path="/" element={<PriceRequestList />} />
        </Routes>
    );
}

export default PriceRequestPage;
